(function () {
  const defaultI18n = {
    send: 'Submit',
    sending: 'Submitting…',
    success: 'Thank you.',
    submitError: 'Could not submit. Please try again.',
    validationError: 'Please fill in all required fields.',
  };

  const parseI18n = (root) => {
    const node = root.querySelector('[data-product-suggestion-i18n]');
    if (!node) {
      return { ...defaultI18n };
    }
    try {
      return { ...defaultI18n, ...JSON.parse(node.textContent) };
    } catch (error) {
      return { ...defaultI18n };
    }
  };

  const restoreCaret = (input, before, start, end) => {
    if (start === null || end === null) {
      return;
    }
    const diff = before.length - input.value.length;
    const nextStart = Math.max(0, start - diff);
    const nextEnd = Math.max(0, end - diff);
    input.setSelectionRange(nextStart, nextEnd);
  };

  const bindNameFilter = (input) => {
    if (!input || input.dataset.productSuggestionNameBound === 'true') {
      return;
    }
    input.addEventListener('input', () => {
      const start = input.selectionStart;
      const end = input.selectionEnd;
      const before = input.value;
      input.value = input.value.replace(/\d/g, '');
      restoreCaret(input, before, start, end);
    });
    input.dataset.productSuggestionNameBound = 'true';
  };

  const bindPhoneFilter = (input) => {
    if (!input || input.dataset.productSuggestionPhoneBound === 'true') {
      return;
    }
    input.addEventListener('input', () => {
      const start = input.selectionStart;
      const end = input.selectionEnd;
      const before = input.value;
      input.value = input.value.replace(/\D/g, '');
      restoreCaret(input, before, start, end);
    });
    input.dataset.productSuggestionPhoneBound = 'true';
  };

  const resolveShop = (root) => {
    const datasetShop = root.dataset.productSuggestionShop || '';
    if (typeof window.jokerStorefrontShop === 'function') {
      return window.jokerStorefrontShop(datasetShop);
    }
    return String(datasetShop).trim().toLowerCase();
  };

  const buildSubmitUrl = (apiBase, shop) => {
    const base = apiBase.replace(/\/$/, '');
    return `${base}/api/storefront/submit-suggestion?shop=${encodeURIComponent(shop)}`;
  };

  const setFeedback = (root, message, isSuccess) => {
    const feedback = root.querySelector('[data-product-suggestion-feedback]');
    if (!feedback) {
      return;
    }
    feedback.textContent = message || '';
    feedback.classList.toggle('is-success', Boolean(isSuccess));
    feedback.hidden = !message;
  };

  const buildPayload = (root, form) => {
    const formData = new FormData(form);
    const honeypot = String(formData.get('website') || '').trim();
    if (honeypot) {
      return null;
    }

    const shop = resolveShop(root);
    const productId = String(root.dataset.productSuggestionProductId || '').trim();
    const productTitle = String(root.dataset.productSuggestionProductTitle || '').trim();
    const subject = String(formData.get('subject') || '').trim();
    const authorName = String(formData.get('authorName') || '').trim();
    const phone = String(formData.get('phone') || '').trim();
    const authorEmail = String(formData.get('authorEmail') || '').trim();
    const body = String(formData.get('body') || '').trim();

    if (!shop || !productId || !productTitle || !subject || !authorName || !phone || !authorEmail || !body) {
      return { invalid: true };
    }

    return {
      shop,
      productId,
      productTitle,
      subject,
      authorName,
      phone,
      authorEmail,
      body,
    };
  };

  const submitForm = async (root, form, i18n) => {
    const apiBase = root.dataset.productSuggestionApi || '';
    const submitButton = root.querySelector('[data-product-suggestion-submit]');
    const defaultLabel = i18n.send || submitButton?.textContent || '';
    const payload = buildPayload(root, form);

    if (!payload) {
      setFeedback(root, i18n.success, true);
      form.reset();
      return;
    }

    if (payload.invalid) {
      setFeedback(root, i18n.validationError, false);
      return;
    }

    if (!apiBase) {
      setFeedback(root, i18n.submitError, false);
      return;
    }

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = i18n.sending || defaultLabel;
    }

    try {
      const response = await fetch(buildSubmitUrl(apiBase, payload.shop), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        throw new Error(data.error || i18n.submitError);
      }
      setFeedback(root, data.message || i18n.success || '', true);
      form.reset();
    } catch (error) {
      setFeedback(root, error.message || i18n.submitError || '', false);
    } finally {
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.textContent = defaultLabel;
      }
    }
  };

  const initSuggestionRoot = (root) => {
    if (root.dataset.productSuggestionInitialized === 'true') {
      return;
    }

    const form = root.querySelector('[data-product-suggestion-form]');
    const i18n = parseI18n(root);

    bindNameFilter(root.querySelector('[data-product-suggestion-name]'));
    bindPhoneFilter(root.querySelector('[data-product-suggestion-phone]'));

    if (form) {
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        submitForm(root, form, i18n);
      });
    }

    root.dataset.productSuggestionInitialized = 'true';
  };

  const init = (scope) => {
    scope.querySelectorAll('[data-product-suggestion]').forEach(initSuggestionRoot);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
